import React, { FC, ReactElement } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen'
import { useUserContext } from '~/hooks/UserContext'
import styles from './UserHeader.module.scss'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import { galleryUrl } from '~/modules/Gallery/url'

interface UserHeaderProps {
  profile: ProfileDto
}

export const UserHeader: FC<UserHeaderProps> = ({ profile }) => {
  const { t } = useTranslation('my_collection')
  const { user } = useUserContext()
  let galleryLink: ReactElement | null = null
  let sinceField: ReactElement | null = null
  let userName = ''

  if (user !== null) {
    userName = user?.name ?? ''

    if (user?.createdAt !== null) {
      sinceField = (
        <span className={ styles.userHeader__userSince }>
        <Trans
          i18nKey={ t('user_header_title') }
          values={ { date: user?.createdAt } }
          components={ [
            <span className={ styles.userHeader__userCreatedAt } key={ userName }>
            </span>,
          ] }
        />
      </span>
      )
    }

    if (profile.slug) {
      const link = `${galleryUrl}/${profile.slug}`

      galleryLink = (
        <a href={ link }>
          { link }
        </a>
      )
    } else {
      galleryLink = (
        <span className={ styles.userHeader__gallery__link }>
          { t('user_header_no_gallery_link') }
        </span>
      )
    }
  }

  return (
    <div className="container flex justify-between ">
      <Link
        className={ styles.userHeader__editProfile }
        title={ t('user_header_edit_profile') }
        href="/profile?backlink"
        passHref
      >
        <FontAwesomeIcon
          className={ styles.userHeader__editProfileIcon }
          icon={ faPen }
        />
      </Link>

      <div className={ styles.userHeader__container }>
        <span className={ styles.userHeader__userName }>
          { sinceField }

          { userName }
        </span>

        {
          user
            ? <div className={ styles.userHeader__gallery__container }>
                <span className={ styles.userHeader__gallery__title }>
                  { t('user_header_gallery_title') }
                </span>

                { galleryLink }
            </div>
            : null
        }
      </div>
    </div>
  )
}
